/* eslint-disable @typescript-eslint/ban-ts-comment */
// @ts-nocheck

window.XPEDEO_SETTINGS = {
  content: {
    remoteUrl: '',
    useStaticPageFiles: false
  },
  theme: 't-clear-inverse t-sch-mans',
  showLocationSettingsWarning: true
}
